import React from 'react';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'url-search-params-polyfill';

import Modal, { ModalTransition } from '@atlaskit/modal-dialog';

import AddToTestCycleDialogForm from './AddToTestCycleDialogForm';

type Props = {
  projectId: string;
  onClose: () => void;
  testCaseIds: Array<number>;
};

export default function AddToTestCycleDialog(props: Props): JSX.Element {
  return (
    <ModalTransition>
      <Modal
        onClose={props.onClose}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEscapePress={true}
        shouldScrollInViewport
      >
        <AddToTestCycleDialogForm {...props} />
      </Modal>
    </ModalTransition>
  );
}
